import type { MeetingMinute } from '../types/crm';

export type MeetingMinuteStatus = 'draft' | 'posted';

export function isMeetingMinutePosted(minute: Pick<MeetingMinute, 'status' | 'posted_at'>): boolean {
  return minute.status === 'posted' || Boolean(minute.posted_at);
}

export function minuteAttendees(minute: MeetingMinute): string {
  return minute.attendees?.trim() ?? '';
}

export function minuteDiscussion(minute: MeetingMinute): string {
  return (minute.discussion ?? minute.body ?? '').trim();
}

export function minuteStatusLabel(minute: MeetingMinute): string {
  return isMeetingMinutePosted(minute) ? 'Posted' : 'Draft';
}
